import { animate, animateChild, group, query, state, style, transition, trigger } from '@angular/animations';
import { appConfig } from 'src/config';

const _showEnterTime = appConfig.show_enter_time;
const _showLeaveTime = appConfig.show_leave_time;
const _showHideEnterTime = appConfig.showHide_enter_time;
const _showHideLeaveTime = appConfig.showHide_leave_time;

export const showAnimation = [
    trigger('showHide', [
        transition(':enter', [
            style({ opacity: '0' }),
            animate('{{enterTime}} ease-in-out', style({ opacity: '1' })),
        ],
        { params: {enterTime: _showHideEnterTime} }),
        transition(':leave', [
            style({ opacity: '1' }),
            animate('{{leaveTime}} ease-in-out', style({ opacity: '0' })),
        ],
        { params: {leaveTime: _showHideLeaveTime} }),
    ]),
    trigger('showHideVisible', [
        state('true', style({ opacity: '1' })),
        state('false', style({ opacity: '0' })),
        transition('* => true', [
            animate('{{enterTime}} ease-in-out'),
        ],
        { params: {enterTime: _showEnterTime} }),
        transition('* => false', [
            animate('{{leaveTime}} ease-in-out'),
        ],
        { params: {leaveTime: _showLeaveTime} }),
    ]),
    trigger('show', [
        transition(':enter', [
            style({ opacity: '0' }),
            animate('{{enterTime}} ease-in-out', style({ opacity: '1' })),
        ],
        { params: {enterTime: _showEnterTime} }),
        transition(':leave', [
            style({ opacity: '1' }),
            animate('{{leaveTime}} ease-in-out', style({ opacity: '0' })),
        ],
        { params: {leaveTime: _showLeaveTime} }),
    ]),
    trigger('showHeightCollapse', [
        transition(':enter', [
            style({ height: '0', opacity: '0' }),
            group([
                animate('{{enterTime}} ease-in-out', style({ height: '*', opacity: '1' })),
        query('@showHide', animateChild(), { optional: true }),
            ]),
        ],
        { params: {enterTime: _showEnterTime} }),
        transition(':leave', [
            style({ height: '*', opacity: '1' }),
            group([
                animate('{{leaveTime}} ease-in-out', style({ height: '0', opacity: '0' })),
                query('@showHide', animateChild(), { optional: true }),
            ]),
        ],
        { params: {leaveTime: _showLeaveTime} }),
    ],
),
];
